import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';

function EmptyExperiences() {
  return (
    <tr className="border border-gray-300 bg-gray-50">
      <td colSpan={8} className="">
        <div className="flex flex-col justify-center items-center text-gray-500 pt-20 pb-16">
          <div className="font-bold text-lg">
            <T kind="Programs will show up here" />
          </div>
          <div>
            <T kind="You haven't added any programs to this collection..." />
          </div>
        </div>
      </td>
    </tr>
  );
}

export default observer(EmptyExperiences);
